module.exports = require("./seh-MZ");